import React from "react"
import { inputBox } from "./input.module.css"

export const Select = ( {
  name,
  input,
  options = "",
  disabled = false,
} ) => {
  return (
    <span className={ inputBox }>
      <select
        name={ name }
        disabled={ disabled }
        value={ input.values[ name ] }
        onChange={ ( e ) => input.setValues( {
          ...input.values,
          [ name ]: e.target.value
        } ) }
        onBlur={ ( e ) => input.setValues( {
          ...input.values,
          [ name ]: e.target.value
        } ) }
      >
        { Object.keys( options ).map( key => (
          <option key={ key } value={ key }>{ options[ key ] }</option>
        ) ) }
      </select>
    </span>
  )
}

export default Select